import _ from 'underscore';
const {Backbone} = require('backboneAdapter');
import GenericModel from 'js/models/generic.model';
require('moment');

    export default GenericModel.extend({
        defaults: {
            campaignTitle: "",
            campaignUUID: "",
            contact: {
                firstname: "",
                lastname: "",
                email: "",
                msisdn: ""
            },
            question: {
                title: "",
                answer: null
            },
            responseDate: null,
            rating: null,
            subscriberId: null,
            subscriptionId: null
        }
    });
